import React, { useEffect } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import { Link } from 'react-router-dom';

const CloudDevOps = () => {
    useDocTitle('NexAI Solution | Cloud & DevOps')

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div>
                <NavBar />
            </div>
            
            <div className="flex flex-col justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container mx-auto px-4 lg:px-20" data-aos="zoom-in">
                    <h1 className="text-5xl font-bold text-center text-blue-900 mb-6">Cloud & DevOps</h1>
                    <div className='flex justify-center mb-12'>
                        <div className='w-24 border-b-4 border-blue-900'></div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                        <div className="bg-white p-8 rounded-2xl shadow-2xl">
                            <h2 className="text-3xl font-semibold text-blue-900 mb-6">Cloud Services</h2>
                            <p className="text-gray-600 mb-6 text-lg">
                                Modernize your infrastructure with our comprehensive cloud solutions.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Cloud Migration</h3>
                                        <p className="text-gray-600 mt-2">Seamless migration of your applications and data to the cloud.</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Cloud Architecture</h3>
                                        <p className="text-gray-600 mt-2">Design and implement scalable cloud infrastructure.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-8 rounded-2xl shadow-2xl">
                            <h2 className="text-3xl font-semibold text-blue-900 mb-6">DevOps Solutions</h2>
                            <p className="text-gray-600 mb-6 text-lg">
                                Accelerate your development lifecycle with our DevOps practices.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">CI/CD Implementation</h3>
                                        <p className="text-gray-600 mt-2">Automated pipelines for continuous integration and deployment.</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Infrastructure as Code</h3>
                                        <p className="text-gray-600 mt-2">Automated infrastructure provisioning and management.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-12">
                        <Link to="/contact#contact" 
                           className="bg-blue-900 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-800 transition duration-300">
                            Transform Your Infrastructure
                        </Link>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default CloudDevOps;
